import { render, staticRenderFns } from "./StoryWidget.vue?vue&type=template&id=3d715c4b&scoped=true&"
import script from "./StoryWidget.vue?vue&type=script&lang=js&"
export * from "./StoryWidget.vue?vue&type=script&lang=js&"
import style0 from "./StoryWidget.vue?vue&type=style&index=0&id=3d715c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d715c4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VScrollYTransition})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
